import { deleteJson, getJson, postJson, putJson, patchJson } from './baseApi'

export const fetchOffersByAffiliateId = (affiliateId) => {
	return getJson(`/api/marketplace/offers/affiliate/${affiliateId}`)
}

export const updatePricingScheme = (offerId, command) => {
	return putJson(`/api/marketplace/offers/${offerId}/update-pricing-scheme`, command)
}